<template>
  <div>
    <div class="filter-tab">
      <div v-for="(item, index) in tabs" :key="item.value" class="tabs-item">
        <span
          class="item-label"
          :class="{ select: tabSelect == item.value }"
          @click="tanChange(item.value)"
        >
          {{ item.label }}
        </span>
        <span v-if="index != tabs.length - 1" class="divider">|</span>
      </div>
    </div>
    <div class="list" v-if="list.length > 0">
      <div v-for="(item, index) in list" :key="index" class="item-card">
        <MeetingCard
          :item="{ ...item, class_teacher_name: item.teacher_name }"
          :showTime="true"
          @goToPlay="goToPlay"
        />
      </div>
    </div>
    <EmptyNew v-else title="暂无班会"></EmptyNew>
  </div>
</template>
<script>
import EmptyNew from '@/components/EmptyNew.vue';
import MeetingCard from './MeetingCard';

export default {
  name: 'MemberClassesMeeting',
  components: {
    EmptyNew,
    MeetingCard,
  },
  data() {
    return {
      tabSelect: 2,
      list: [],
      id: this.$route.params.id,
      tabs: [
        {
          label: '直播中',
          value: 2,
        },
        {
          label: '未开始',
          value: 3,
        },
        {
          label: '已结束',
          value: 4,
        },
        {
          label: '全部',
          value: 1,
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const list = await this.$http.get(`/api/app/user/classMeeting/${this.id}/${this.tabSelect}`);
      this.list = list;
    },
    //直播，回放
    goToPlay(item, type) {
      this.$livePlay(0, 'meeting', {
        id: 0,
        title: item.meeting_name,
        meeting_id: item.id,
        type: type,
      });
    },
    tanChange(value) {
      this.tabSelect = value;
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-tab {
  margin: 16px 24px 20px 24px;
  display: flex;
  .tabs-item {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999999;
    span {
      vertical-align: middle;
    }
    .item-label {
      cursor: pointer;
    }
    .item-label:hover {
      color: #fc5623;
    }
    .select {
      color: #fc5623;
    }
    span.divider {
      display: inline-block;
      padding: 0 12px;
      font-size: 13px;
      vertical-align: middle;
    }
  }
}
.list {
  padding: 0 24px 30px 0;
  .item-card {
    &:last-child {
      ::v-deep .line::after {
        display: none;
      }
      ::v-deep .main {
        margin-bottom: 0;
      }
    }
  }
}
</style>
